import React from 'react';
import toast from 'react-hot-toast';

import { CrossIcon, TickIcon } from '~/assets';
import NewsIcon from '~/assets/NewsIcon';
import {
  CrossContainer,
  DownloadContainer,
  InfoContainer,
  InformationContainer,
  SpinnerIcon,
  StyledCrossIcon,
  TickContainer,
} from '~/components/ToastComponent/ToastComponent.styles';

export enum ToastMode {
  Success,
  Error,
  Information,
  Loading,
}
interface ToastComponentProps {
  text: string;
  id?: string;
  mode?: ToastMode;
  darkMode?: boolean;
  // Overrides the default Success/Error icon background (theme.colors.success / darkRed), e.g.
  // for a caller with its own exact design-token color to match.
  iconBackgroundColor?: string;
  // Overrides the toast's default sizing (min-width/gap/border-radius), e.g. for a caller with
  // its own exact size spec.
  width?: string;
  height?: string;
  gap?: string;
  borderRadius?: string;
  borderColor?: string;
  boxShadow?: string;
}

const ToastComponent = ({
  text,
  id,
  mode,
  darkMode = false,
  iconBackgroundColor,
  width,
  height,
  gap,
  borderRadius,
  borderColor,
  boxShadow,
}: ToastComponentProps) => {
  const getIcon = () => {
    switch (mode) {
      case ToastMode.Success:
        return (
          <TickContainer $iconBackgroundColor={iconBackgroundColor}>
            <TickIcon />
          </TickContainer>
        );
      case ToastMode.Error:
        return (
          <CrossContainer $iconBackgroundColor={iconBackgroundColor}>
            <CrossIcon />
          </CrossContainer>
        );
      case ToastMode.Loading:
        return <SpinnerIcon />;
      default:
        return (
          <InformationContainer>
            <NewsIcon />
          </InformationContainer>
        );
    }
  };

  return (
    <DownloadContainer
      $darkMode={darkMode}
      $width={width}
      $height={height}
      $gap={gap}
      $borderRadius={borderRadius}
      $borderColor={borderColor}
      $boxShadow={boxShadow}
    >
      <InfoContainer>
        {getIcon()}
        {text}
      </InfoContainer>
      <StyledCrossIcon onClick={() => toast.remove(id)} />
    </DownloadContainer>
  );
};

export default ToastComponent;
